import server from "../../../server";
import { Note, NoteStatus } from "../../../domains/models/note";
import { NotePayload } from "../type/my-notes-page.types";
import dayjs from 'dayjs';
import Locale from "../../../core/locale/locale";

export async function getNotes(data?: any) {
    const searchData={
        ...data
    }
    const res = await server.notes.list(searchData);
    return res;
}

export async function createNote(payload: any) {
    const res = await server.notes.create(payload);
    return res;
}

export async function editNote(id: string, payload: any) {
    console.log(id, 'notes ID')
    const res = await server.notes.update(id, payload);
    return res;
}

export async function deleteNote(id: string) {
    try {
        await server.notes.delete(id);
        return true;
    } catch (e) {
        console.log('error encountered', e);
        return false;
    }
}

export async function markStatus(id: string, status: NoteStatus) {
    //status api
    const res = await server.notes.updateStatus(id, status);
    return res;
}

export async function markNoteAsPinned(id: string, isPinned: boolean) {
    const res = await server.notes.updateStatus(id, undefined, isPinned);
    return res;
}


export function mapFormValuesToPayload(values: any): NotePayload {
    let type = 'NOTE';
    if (values.dueDate) {
        type = 'TODO';
    }
    const dueDateString = values.dueDate ? dayjs(values.dueDate).format(Locale.dateFormat) : undefined;
    return {
        id: values.id,
        type: type,
        title: values.title,
        content: values.content,
        dueDate: dueDateString,
        colorKey: values.colorKey,
        priority: values.priority,
        tag: values.tag
    }

}


export function mapNoteToFormValue(note: Note) {
    const dueDatePickerVal = note.dueDate?dayjs(note.dueDate):undefined;
    return {
        id: note.id,
        title: note.title,
        content: note.content,
        dueDate: dueDatePickerVal,
        pinned: note.pinned,
        colorKey: note.colorKey,
        priority: note.priority,
        tag: note.tag
    }

}
